"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class URL {
    static getParameters() {
        var _a;
        const queryString = window.location.search.substring(1).split('&');
        if (queryString[0] === '' && queryString.length === 1) {
            return {};
        }
        const parameters = {};
        for (let index = 0; index < queryString.length; ++index) {
            const param = (_a = queryString[index]) === null || _a === void 0 ? void 0 : _a.split('=', 2);
            if (param.length === 1) {
                parameters[param[0]] = '';
            }
            else {
                parameters[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '));
            }
        }
        return parameters;
    }
    /**
     * Returns the value of the parameter with the given name.
     *
     * @param paramName
     */
    static hasParameter(paramName) {
        var _a;
        return (_a = !URL.getParameters()[paramName]) !== null && _a !== void 0 ? _a : false;
    }
    /**
     *
     * @param url
     * @param paramName
     * @param paramValue
     */
    static setParameter(url, paramName = '', paramValue = '') {
        const pattern = new RegExp(`\\b(${paramName}=).*?(&|#|$)`);
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/, '');
        return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    /**
     *
     * @param key
     * @param url
     */
    static removeParameter(key, url) {
        let rtn = url.split('?')[0];
        let param;
        let params_arr = [];
        const queryString = url.indexOf('?') !== -1 ? url.split('?')[1] : '';
        if (queryString !== '') {
            params_arr = queryString.split('&');
            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + '?' + params_arr.join('&');
        }
        return rtn;
    }
    /**
     *
     * @param urlParameters
     */
    static updateUrl(urlParameters) {
        if (!window.history) {
            return;
        }
        const querystring = Object.keys(urlParameters)
            .map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(urlParameters[key])}`;
        })
            .join('&');
        let newUrl = `${window.location.pathname}`;
        if (querystring !== '') {
            newUrl = `${window.location.pathname}?${querystring}`;
        }
        window.history.pushState(null, '', newUrl);
    }
}
exports.default = URL;
